class Collection {
  constructor() {
    this.selectors = {
      section: ".facest-filters-section",
      toolbar: ".m-collection-toolbar",
      cols: [".m-toolbar--column-switcher button"],
      productContainer: "[data-product-container]",
      loadMoreBtn: "[data-load-more]",
      sidebar: ".m-sidebar",
      sidebarContent: ".m-sidebar--content",
      openSidebar: ".m-sidebar--open",
      closeSidebar: ".m-sidebar--close",
      filtersWrapper: ".m-filter--wrapper",
    };

    this.mobileSortingSelectors = {
      openSorting: ".m-sortby--open",
      closeSorting: ".m-sortby-mobile--close",
      sortingWrapper: ".m-sortby-mobile--wrapper",
      sortingList: ".m-sortby-mobile--content",
    };

    this.sectionId = "";
    this.isDesignMode = MinimogSettings.design_mode;
    this.currentPage = 1;
    this.paginationType;
    this.totalPages;
    this.totalProducts;
    this.infiniteLoadingObserver;
    this.showColSwitchers;
    this.cachedCol;
    this.initialCol;
    this.activeCol;
    this.STORAGE_KEY = "gridColumnViews";
    this.MAX_COL_BY_SCREEN_SIZE = {
      mobile: 2,
      tablet: 4,
      desktop: 5,
    };
    this.enableFilters;
    this.enableSorting;
    this.filtersType;
    this.filtersPosition;
    this.accordions;
    this.sideEffectEventsAdded = !1;
  }

  init = () => {
    this.domNodes = queryDomNodes(this.selectors);
    this.mbSortingNodes = queryDomNodes(this.mobileSortingSelectors);
    this.setData();
    this.initGridView();
    this.initFilters();
    this.initMobileSorting();
    this.initProducts();
    this.sideEffectEventsAdded = !0;

    MinimogEvents.subscribe("ON_PRODUCT_LIST_UPDATED", () =>
      refreshProductReview()
    );

    this.handleStickyToolbar();

    document.addEventListener("matchMobile", () =>
      this.handleStickyToolbar()
    );
    document.addEventListener("unmatchMobile", () =>
      this.handleStickyToolbar()
    );
  };

  setData = () => {
    const { section, productContainer } = this.domNodes;

    this.sectionId = section.dataset.sectionId;
    this.paginationType = section.dataset.paginationType;
    this.totalPages = productContainer && Number(productContainer.dataset.totalPages);
    this.view = section.dataset.view;
    this.activeCol = null;
    this.currentPage = 1;
    this.initialCol = Number(section.dataset.initialColumn);
    this.cachedCol =
      Number(window.localStorage.getItem(this.STORAGE_KEY)) || this.initialCol;
    this.showColSwitchers = "true" === section.dataset.showColSwitchers;
    this.enableFilters = "true" === section.dataset.enableFilters;
    this.enableSorting = "true" === section.dataset.enableSorting;
    this.filtersType = section.dataset.filtersType;
    this.filtersPosition = section.dataset.filtersPosition;
  };

  initGridView = () => {
    this.toggleView(this.isDesignMode ? this.initialCol : this.cachedCol);
    this.updateViewByScreen();

    addEventDelegate({
      selector: this.selectors.cols[0],
      context: this.domNodes.toolbar,
      handler: (t, e) => this.toggleView(Number(e.dataset.column)),
    });

    this.initLoadMore();

    this.sideEffectEventsAdded ||
      window.addEventListener("resize", debounce(this.updateViewByScreen, 500));
  };

  initFilters = () => {
    if (!this.enableFilters) return;

    const { sidebar, openSidebar, closeSidebar } = this.domNodes;

    window.requestAnimationFrame(this.initAccordions);
    openSidebar.addEventListener("click", this.openSidebarFilter);
    closeSidebar.addEventListener("click", this.closeSidebarFilter);
    sidebar.addEventListener("click", (e) =>
      e.target === sidebar && this.closeSidebarFilter()
    );
  };

  initMobileSorting = () => {
    if (!this.enableSorting) return;

    const { openSorting, closeSorting, sortingWrapper } = this.mbSortingNodes;

    openSorting.addEventListener("click", this.openMobileSorting);
    closeSorting.addEventListener("click", this.closeMobileSorting);
    sortingWrapper.addEventListener("click", (t) =>
      t.target === sortingWrapper && this.closeMobileSorting()
    );
  };

  openMobileSorting = () => {
    const { sortingWrapper, sortingList } = this.mbSortingNodes;

    sortingWrapper.style.display = "block";

    window.requestAnimationFrame(() => {
      sortingWrapper.style.setProperty("--m-bg-opacity", "0.5");
      sortingList.style.setProperty("--m-translate-y", "0");
    });
  };

  closeMobileSorting = (t) => {
    const { sortingWrapper, sortingList } = this.mbSortingNodes;

    sortingWrapper.style.setProperty("--m-bg-opacity", "0");
    sortingList.style.setProperty("--m-translate-y", "100%");

    setTimeout(() => sortingWrapper.style.setProperty("display", "none"), 300);
  };

  initAccordions = () => {
    this.accordions && this.accordions.destroy();

    const { filtersWrapper } = this.domNodes;

    filtersWrapper.classList.remove("acc-initialized");

    this.accordions = new MinimogLibs.Accordion(filtersWrapper, {
      presetContentHeight:
        window.innerWidth > 1280 && "fixed" !== this.filtersPosition,
      callback: () => filtersWrapper.style.setProperty("opacity", "1"),
    });
  };

  openSidebarFilter = () => {
    const { sidebar, sidebarContent, section } = this.domNodes;

    sidebar.style.display = "block";

    window.requestAnimationFrame(() => {
      sidebar.style.setProperty("--m-bg-opacity", "0.5");
      sidebarContent.style.setProperty("--m-translate-x", "0");
      this.accordions && this.accordions.setContentHeight();
    });

    section.classList.add("sidebar-open");
  };

  closeSidebarFilter = () => {
    const { sidebar, sidebarContent, section } = this.domNodes;

    section.classList.remove("sidebar-open");

    (window.innerWidth < 1280 || "fixed" === sidebar.dataset.type) &&
      (sidebarContent.style.setProperty("--m-translate-x", "-100%"),
      sidebar.style.removeProperty("--m-bg-opacity"),
      setTimeout(() => sidebar.style.removeProperty("display"), 300));
  };

  toggleView = (t) => {
    if (!t || "search" === this.view) return;

    const { cols, productContainer } = this.domNodes;
    if (!productContainer) return;

    const images = productContainer.querySelectorAll("responsive-image");

    images &&
      images.length > 0 &&
      images.forEach((t) => {
        t.disconnectedCallback();
        t.connectedCallback();
      });

    const oldCol = this.activeCol || this.initialCol;

    this.showColSwitchers &&
      (cols[oldCol - 1].classList.remove("active"),
      cols[t - 1].classList.add("active"));

    productContainer.classList.remove(`m-cols-${oldCol}`);
    productContainer.classList.add(`m-cols-${t}`);
    window.localStorage.setItem(this.STORAGE_KEY, t);
    this.activeCol = t;

     const bestsellerTags = document.querySelectorAll(".m-product-tag--bestseller");
console.warn(bestsellerTags , t , this.activeCol )
    if (t === 1) {
        bestsellerTags.forEach(el => {
        el.classList.add("ATS-bestseller-list")
      });
      
    } else {
       bestsellerTags.forEach(el => {
       el.classList.remove("ATS-bestseller-list")
      });
    }

    
  };

  updateViewByScreen = () => {
    if (1 === this.activeCol) return;

    const device = this.getDeviceByScreenSize();
    const maxCol = this.MAX_COL_BY_SCREEN_SIZE[device];

    maxCol < this.activeCol && this.toggleView(maxCol);
  };

  getDeviceByScreenSize = () =>
    window.innerWidth < 768
      ? "mobile"
      : window.innerWidth < 1024
      ? "tablet"
      : "desktop";

  initLoadMore = () => {
    if (
      "paginate" === this.paginationType ||
      this.totalPages <= 1 ||
      "search" === this.view
    )
      return;

    const { loadMoreBtn } = this.domNodes;

    loadMoreBtn.addEventListener("click", this.loadMoreProducts);

    "infinite" === this.paginationType &&
      (this.infiniteLoadingObserver = new IntersectionObserver(
        (t) => {
          t.forEach((t) => {
            1 === t.intersectionRatio && this.loadMoreProducts();
          });
        },
        { threshold: 1 }
      ),
      this.infiniteLoadingObserver.observe(loadMoreBtn));
  };

  loadMoreProducts = () => {
    const nextPage = this.currentPage + 1;
    if (nextPage > this.totalPages) return;

    const { productContainer, loadMoreBtn } = this.domNodes;

    this.toggleLoading(!0);

    fetchSection(this.sectionId, {
      fromCache: !0,
      params: { page: nextPage },
    })
      .then((t) => {
        t.querySelectorAll("[data-product-container] .m-product-item").forEach(
          (t) => productContainer.appendChild(t)
        );
        this.initProducts();
      })
      .catch((t) => {})
      .finally(() => {
        MinimogEvents.emit("ON_PRODUCT_LIST_UPDATED");
        this.toggleLoading(!1);
        this.currentPage = nextPage;

        nextPage >= this.totalPages &&
          (loadMoreBtn.parentNode.remove(),
          this.infiniteLoadingObserver &&
            this.infiniteLoadingObserver.unobserve(loadMoreBtn));
      });
  };

  initProducts = () => {
    MinimogTheme.CompareProduct &&
      MinimogTheme.CompareProduct.setCompareButtonsState();

    MinimogTheme.Wishlist &&
      MinimogTheme.Wishlist.setWishlistButtonsState();
  };

  toggleLoading = (t) => {
    const { loadMoreBtn } = this.domNodes;

    if (loadMoreBtn) {
      const method = t ? "add" : "remove";
      loadMoreBtn.classList[method]("m-spinner-loading");
    }
  };

  handleStickyToolbar() {
    const toolbar = this.domNodes.toolbar;
    const offsetTop = toolbar && toolbar.offsetTop;
    let lastScroll = 0;

    window.addEventListener("scroll", () => {
      if (MinimogTheme.config.mqlMobile) {
        const currentScroll = window.scrollY;

        if (currentScroll <= offsetTop) {
          return void toolbar.classList.remove(
            "scroll-up",
            "m-collection-toolbar--sticky"
          );
        }

        toolbar.classList.add("m-collection-toolbar--sticky");

        currentScroll > toolbar.offsetHeight + offsetTop &&
        currentScroll > lastScroll &&
        !toolbar.classList.contains("scroll-down")
          ? (toolbar.classList.remove("scroll-up"),
            toolbar.classList.add("scroll-down"))
          : currentScroll < lastScroll &&
            toolbar.classList.contains("scroll-down") &&
            (toolbar.classList.remove("scroll-down"),
            toolbar.classList.add("scroll-up"));

        lastScroll = currentScroll;
      } else {
        toolbar.classList.remove(
          "scroll-up",
          "m-collection-toolbar--sticky",
          "scroll-down"
        );
      }
    });
  }
}